import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getAmendHistoryList = createAsyncThunk('/prosafe/po/get-po-history',
    async ({ payload }) => {
        try {
            const myurl = `${V_URL}/prosafe/po/get-po-history`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN'),
                },
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error
        }
    })

const getAmendHistoryListSlice = createSlice({
    name: "getAmendHistoryList",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetAmendHistoryList: (state) => {
            state.user = null;
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAmendHistoryList.pending, (state) => {
                state.loading = true;
                state.user = null;
                state.error = null;
            })
            .addCase(getAmendHistoryList.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAmendHistoryList.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export const { resetAmendHistoryList } = getAmendHistoryListSlice.actions;
export default getAmendHistoryListSlice.reducer;